import React, { useEffect, useState } from "react";
import Row from 'react-bootstrap/Row'
import {
    Container,
    Typography,
    TextField,
    Grid,
    Box,
    FormControl,
    MenuItem,
    Button,
    makeStyles,
} from "@material-ui/core";
import { IoMdArrowBack } from 'react-icons/io'
import Palette from "../../Palette";
import Member from "../../models/Member";
import Swal from "sweetalert2";
import Alert from "../../components/Alert";
import { useHistory } from "react-router-dom";
import Provinces from "../../util/ProvinceData";
import Select from 'react-select';
import Cities from "../../util/CityData";

const useStyles = makeStyles({
    noBorderInput: {
        '& .MuiOutlinedInput-root': {
            backgroundColor: '#e9f3f4',
            '& fieldset': {
                border: 'none !important',
            },
            '&:hover fieldset': {
                border: 'none !important',
            },
            '&.Mui-focused fieldset': {
                border: 'none !important',
            },
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: 'none !important',
        },
        '& fieldset': {
            border: 'none !important',
        },
    },
});

export default function MitraAccountContactForm({ props }) {
    const modelMember = new Member()
    const history = useHistory()
    const classes = useStyles();
    const [errorMsg, setErrorMsg] = useState(null);
    const [errors, setErrors] = useState({});

    // Data Perusahaan/Lembaga
    const [fullName, setFullName] = useState(null); //Nama Perusahaan/Lembaga
    const [mitraEntity, setMitraEntity] = useState(null); // PT/CV/FOUNDATION/CORPORATION
    const [mitraPolicyNumber, setMitraPolicyNumber] = useState(null); //Nomor Induk Berusaha (NIB)/Izin Usaha
    const [addressStreet, setAddressStreet] = useState(null); //Alamat Kantor
    const [addressRegion, setAddressRegion] = useState(null); //Provinsi
    const [addressLocality, setAddressLocality] = useState(null); //Kota/Kabupaten
    const [addressPostal, setAddressPostal] = useState(null);  //Kode Pos
    const [phoneNumber, setPhoneNumber] = useState(null); //No Telepon
    const [emailAddress, setEmailAddress] = useState(null); //Email
    const [websiteURL, setWebsiteURL] = useState(null); //Website Resmi


    const provinceOptionList = Provinces.map((value) => ({ label: value.province, value: value.province_id }))
    const cityOptionList = addressRegion
        ? Cities.filter((city) => city.province === addressRegion).map((city) => ({
            label: city.city_name,
            value: city.city_id
        }))
        : [];


    const handleSubmit = async (e) => {
        try {
            setErrors({});
            setErrorMsg(null);

            const confirmResult = await Swal.fire({
                title: 'Konfirmasi',
                text: 'Apakah Anda yakin ingin menyimpan perubahan data profil?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#0000FF',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ya, Simpan',
                cancelButtonText: 'Batal',
            });

            if (!confirmResult.isConfirmed) {
                return;
            }

            const payload = {
                full_name: fullName,
                mitra_entity: mitraEntity,
                mitra_policy_number: mitraPolicyNumber,
                address_street: addressStreet,
                address_region: addressRegion,
                address_locality: addressLocality,
                address_postal: addressPostal,
                phone_number: phoneNumber,
                // email: emailAddress,
                website_url: websiteURL,
            }
            await modelMember.editMemberData(payload)

            Swal.fire({
                icon: 'success',
                title: 'Berhasil',
                text: 'Data profil berhasil disimpan',
                confirmButtonText: 'OK',
                confirmButtonColor: '#0000FF',
            }).then(() => {
                history.push('/member/akun');
            })

        } catch (e) {
            Swal.fire({
                icon: 'error',
                title: 'Terjadi Kesalahan',
                text: e?.error_message || e?.message || 'Gagal mengirim data. Silakan coba lagi.',
            })
            console.error(e)
        } finally {

        }
    }


    const fetchSelfData = async () => {
        try {
            let result = await modelMember.getMemberData()
            const memberData = result?.member

            if (memberData) {
                // Set Data Perusahaan/Lembaga
                setFullName(memberData.full_name);
                setMitraEntity(memberData.mitra_entity);
                setMitraPolicyNumber(memberData.mitra_policy_number);
                setAddressStreet(memberData.address_street);
                setAddressRegion(memberData.address_region);
                setAddressLocality(memberData.address_locality);
                setAddressPostal(memberData.address_postal);
                setPhoneNumber(memberData.phone_number);
                setEmailAddress(memberData.email);
                setWebsiteURL(memberData.mitra_website);
            }
        } catch (e) {
            console.log('ERROR' + e)
        }
    }

    const handleBackButton = () => {
        history.push('/member/akun');
    }

    useEffect(() => {
        const userStorage = localStorage.getItem('user');
        if (!userStorage) {
            history.replace('/');
            return;
        }

        try {
            const user = JSON.parse(userStorage);
            if (user.role !== 'MITRA_SWASTA') {
                history.replace('/');
                return;
            }
        } catch (e) {
            console.error('Error parsing user data:', e);
            history.replace('/');
            return;
        }

        fetchSelfData()
    }, [history])

    return (
        <>
            <Container maxWidth="lg" sx={{ px: 5, py: 5, fontFamily: 'Signika, sans-serif' }} >

                {
                    errorMsg && <Alert
                        type="error"
                        className="mx-0"
                        errorMsg={errorMsg}
                        textStyle={{ fontSize: 16, fontWeight: 500 }}
                    />
                }

                {/* Data Perusahaan atau Lembaga */}
                <Row>
                    <div
                        onClick={handleBackButton}
                        style={{
                            backgroundColor: 'white',
                            borderColor: 'white',
                            color: 'black',
                            cursor: 'pointer',
                        }}
                        className="p-3"
                    >
                        <IoMdArrowBack size={20} />
                    </div>
                    <div
                        style={{
                            fontFamily: 'Signika',
                            fontWeight: '800',
                            fontSize: '1.75em',
                            color: Palette.PRIMARY,
                        }}
                        className="text-center w-100"
                    >
                        Perbarui Kontak
                    </div>
                </Row>



                <Grid container spacing={3}>
                    {/* Nama Perusahaan/Lembaga */}
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <div
                                style={{
                                    fontFamily: 'Signika',
                                    fontWeight: '600',
                                    fontSize: '0.75em',
                                    color: '#8e8e8e',
                                    marginBottom: 7,
                                }}
                                className="mt-3 text-uppercase"
                            >
                                Nama Perusahaan/Lembaga
                            </div>
                            <TextField
                                fullWidth
                                placeholder="Input Nama Perusahaan / Lembaga"
                                variant="outlined"
                                value={fullName || ''}
                                onChange={(e) => setFullName(e.target.value)}
                                className={classes.noBorderInput}
                                InputProps={{
                                    style: {
                                        fontFamily: 'Signika, sans-serif',
                                    }
                                }}
                                disabled
                            />
                        </FormControl>
                    </Grid>

                    {/* Bentuk Badan Usaha & NIB */}
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <div
                                style={{
                                    fontFamily: 'Signika',
                                    fontWeight: '600',
                                    fontSize: '0.75em',
                                    color: '#8e8e8e',
                                    marginBottom: 7,
                                }}
                                className="mt-3 text-uppercase"
                            >
                                Bentuk Badan Usaha (PT/CV/Yayasan/Koperasi)
                            </div>
                            <TextField
                                fullWidth
                                select
                                placeholder="Pilih Bentuk Badan Usaha"
                                variant="outlined"
                                value={mitraEntity || ''}
                                onChange={(e) => setMitraEntity(e.target.value)}
                                className={classes.noBorderInput}
                                InputProps={{
                                    style: {
                                        fontFamily: 'Signika, sans-serif',
                                    }
                                }}
                                SelectProps={{ sx: { fontFamily: 'Signika, sans-serif' } }}
                                disabled
                            >
                                {
                                    Member.MITRA_SWASTA_ENTITY_OPTIONS.map((option) => {
                                        return (
                                            <MenuItem key={option.value} value={option.value} style={{ fontFamily: 'Signika, sans-serif' }}>
                                                {option.label}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </TextField>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <div
                                style={{
                                    fontFamily: 'Signika',
                                    fontWeight: '600',
                                    fontSize: '0.75em',
                                    color: '#8e8e8e',
                                    marginBottom: 7,
                                }}
                                className="mt-3 text-uppercase"
                            >
                                Nomor Induk Berusaha (NIB)/Izin Usaha
                            </div>
                            <TextField
                                fullWidth
                                placeholder="Input NIB"
                                variant="outlined"
                                value={mitraPolicyNumber || ''}
                                onChange={(e) => setMitraPolicyNumber(e.target.value)}
                                className={classes.noBorderInput}
                                InputProps={{
                                    style: {
                                        fontFamily: 'Signika, sans-serif',
                                    }
                                }}
                                disabled
                            />
                        </FormControl>
                    </Grid>

                    {/* Alamat Kantor */}
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <div
                                style={{
                                    fontFamily: 'Signika',
                                    fontWeight: '600',
                                    fontSize: '0.75em',
                                    color: '#8e8e8e',
                                    marginBottom: 7,
                                }}
                                className="mt-3 text-uppercase"
                            >
                                Alamat Kantor
                            </div>
                            <TextField
                                fullWidth
                                multiline
                                rows={3}
                                placeholder="Input Alamat"
                                variant="outlined"
                                value={addressStreet || ''}
                                onChange={(e) => setAddressStreet(e.target.value)}
                                className={classes.noBorderInput}
                                InputProps={{
                                    style: {
                                        fontFamily: 'Signika, sans-serif',
                                    }
                                }}
                                disabled
                            />
                        </FormControl>
                    </Grid>

                    {/* Provinsi */}
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <div
                                style={{
                                    fontFamily: 'Signika',
                                    fontWeight: '600',
                                    fontSize: '0.75em',
                                    color: '#8e8e8e',
                                    marginBottom: 7,
                                }}
                                className="mt-3 text-uppercase"
                            >
                                Provinsi
                            </div>
                            <Select
                                options={provinceOptionList}
                                value={provinceOptionList.find(opt => opt.label === addressRegion) || null}
                                onChange={(selectedOption) => {
                                    setAddressRegion(selectedOption ? selectedOption.label : null);
                                    setAddressLocality(null);
                                }}
                                placeholder="Pilih Provinsi"
                                isClearable
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        fontFamily: 'Signika, sans-serif',
                                        minHeight: '56px',
                                        fontSize: '16px',
                                        backgroundColor: '#e9f3f4',
                                        border: 'none',
                                    }),
                                    menu: (base) => ({ ...base, fontFamily: 'Signika, sans-serif', fontSize: '16px' }),
                                    option: (base) => ({ ...base, fontFamily: 'Signika, sans-serif', fontSize: '16px' }),
                                    placeholder: (base) => ({ ...base, fontFamily: 'Signika, sans-serif', fontSize: '16px' }),
                                    singleValue: (base) => ({ ...base, fontFamily: 'Signika, sans-serif', fontSize: '16px' }),
                                }}
                                isDisabled
                            />
                        </FormControl>
                    </Grid>

                    {/* Kota/Kabupaten */}
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <div
                                style={{
                                    fontFamily: 'Signika',
                                    fontWeight: '600',
                                    fontSize: '0.75em',
                                    color: '#8e8e8e',
                                    marginBottom: 7,
                                }}
                                className="mt-3 text-uppercase"
                            >
                                Kota/Kabupaten
                            </div>
                            <Select
                                options={cityOptionList}
                                value={cityOptionList.find(opt => opt.label === addressLocality) || null}
                                onChange={(selectedOption) => {
                                    setAddressLocality(selectedOption ? selectedOption.label : null);
                                }}
                                placeholder="Pilih Kota/Kabupaten"
                                isClearable
                                isDisabled
                                /* isDisabled={!addressRegion} */
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        fontFamily: 'Signika, sans-serif',
                                        minHeight: '56px',
                                        fontSize: '16px',
                                        backgroundColor: '#e9f3f4',
                                        border: 'none',
                                    }),
                                    menu: (base) => ({ ...base, fontFamily: 'Signika, sans-serif', fontSize: '16px' }),
                                    option: (base) => ({ ...base, fontFamily: 'Signika, sans-serif', fontSize: '16px' }),
                                    placeholder: (base) => ({ ...base, fontFamily: 'Signika, sans-serif', fontSize: '16px' }),
                                    singleValue: (base) => ({ ...base, fontFamily: 'Signika, sans-serif', fontSize: '16px' }),
                                }}
                            />
                        </FormControl>
                    </Grid>

                    {/* No Telepon & Kode Pos */}
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <div
                                style={{
                                    fontFamily: 'Signika',
                                    fontWeight: '600',
                                    fontSize: '0.75em',
                                    color: '#8e8e8e',
                                    marginBottom: 7,
                                }}
                                className="mt-3 text-uppercase"
                            >
                                No Telepon
                            </div>
                            <TextField
                                fullWidth
                                placeholder="Input No Telepon"
                                variant="outlined"
                                value={phoneNumber || ''}
                                onChange={(e) => setPhoneNumber(e.target.value)}
                                className={classes.noBorderInput}
                                InputProps={{
                                    style: {
                                        fontFamily: 'Signika, sans-serif',
                                    }
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <div
                                style={{
                                    fontFamily: 'Signika',
                                    fontWeight: '600',
                                    fontSize: '0.75em',
                                    color: '#8e8e8e',
                                    marginBottom: 7,
                                }}
                                className="mt-3 text-uppercase"
                            >
                                Kode Pos
                            </div>
                            <TextField
                                fullWidth
                                placeholder="Input Kode Pos"
                                variant="outlined"
                                value={addressPostal || ''}
                                onChange={(e) => setAddressPostal(e.target.value)}
                                className={classes.noBorderInput}
                                InputProps={{
                                    style: {
                                        fontFamily: 'Signika, sans-serif',
                                    }
                                }}
                                disabled
                            />
                        </FormControl>
                    </Grid>

                    {/* Email & Website */}
                    {/* <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <div
                                style={{
                                    fontFamily: 'Signika',
                                    fontWeight: '600',
                                    fontSize: '0.75em',
                                    color: '#8e8e8e',
                                    marginBottom: 7,
                                }}
                                className="mt-3 text-uppercase"
                            >
                                Email
                            </div>
                            <TextField
                                disabled
                                fullWidth
                                type="email"
                                placeholder="Input Email"
                                variant="outlined"
                                value={emailAddress || ''}
                                onChange={(e) => setEmailAddress(e.target.value)}
                                className={classes.noBorderInput}
                                InputProps={{
                                    style: {
                                        fontFamily: 'Signika, sans-serif',
                                    }
                                }}
                            />
                        </FormControl>
                    </Grid> */}
                    <Grid item xs={12} md={12}>
                        <FormControl fullWidth>
                            <div
                                style={{
                                    fontFamily: 'Signika',
                                    fontWeight: '600',
                                    fontSize: '0.75em',
                                    color: '#8e8e8e',
                                    marginBottom: 7,
                                }}
                                className="mt-3 text-uppercase"
                            >
                                Situs Web Resmi
                            </div>
                            <TextField
                                fullWidth
                                placeholder="Input Situs Web Resmi"
                                variant="outlined"
                                value={websiteURL || ''}
                                onChange={(e) => setWebsiteURL(e.target.value)}
                                className={classes.noBorderInput}
                                InputProps={{
                                    style: {
                                        fontFamily: 'Signika, sans-serif',
                                    }
                                }}
                            />
                        </FormControl>
                    </Grid>
                </Grid>


                {/* Simpan Button */}
                <Box mt={4} mb={3}>
                    <Button
                        variant="contained"
                        fullWidth
                        size="large"
                        style={{
                            py: 4,
                            borderRadius: 2,
                            fontSize: "1.125rem",
                            color: "#FFFFFF",
                            fontWeight: "bold",
                            fontFamily: 'Signika, sans-serif',
                            backgroundColor: '#0000FF',
                            '&:hover': {
                                backgroundColor: '#0000FF'
                            }
                        }}
                        onClick={handleSubmit}
                    >
                        Simpan
                    </Button>
                </Box>
            </Container>
        </>

    );
}
